import { useCallback, useEffect, useMemo, useState } from "react";

import { CodeEditor } from "@/components/CodeEditor";
import { useBuilderStore } from "@/components/builder/utils/store";
import { useGlobalTailwindConfig } from "@/components/builder/utils/tailwindConfig/hooks";

import { useBuilder } from "../builder/context";

export default function Preview() {
  const [css, setCSS] = useState("")

  const { compileCSS } = useBuilderStore()
  const { html } = useBuilder()

  const { layers: { base: { css: baseCSS }, utilities: { css: utilitiesCSS } }, tailwindCssConfig: { value: tailwindCssConfig }, theme: { css: themeCSS } } = useGlobalTailwindConfig()

  const tailwindConfig = useMemo(() => ({
    tailwindCssConfig: {
      value: tailwindCssConfig,
    },
    theme: themeCSS,
    mimify: false,
    layers: {
      base: baseCSS,
      utilities: utilitiesCSS,
    },
  }), [tailwindCssConfig, themeCSS, utilitiesCSS, baseCSS])

  const fetchCSS = useCallback(async () => {
    try {
      const css = await compileCSS({ html, tailwindConfig })
      setCSS(css)
    } catch (error) {
      setCSS("")
    }
  }, [html, tailwindConfig, compileCSS])

  useEffect(() => {
    fetchCSS()
  }, [fetchCSS])

  return <CodeEditor value={css} width='100%' height='100%' language='css' readOnly />
}

